import { Component, OnInit, inject, Signal, computed } from '@angular/core';
import { ChangeNavbar, LoadAvailablesLanguages, UpdateCurrentLang } from '@state/global/global.actions';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { GlobalStateSelector } from '@state/global/global.selectors';
import { UserSelectors } from '@state/user/user.selectors';
import { UserLogout } from '@state/user/user.actions';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';

import { TranslocoModule } from '@jsverse/transloco';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { map } from 'rxjs/operators';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { NotificationsMenuComponent } from './notifications-menu/notifications-menu.component';
import { UserDataResult } from "angular-auth-oidc-client";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [MatIconModule, MatToolbarModule, MatSelectModule, TranslocoModule, MatInputModule, FormsModule, MatButtonModule, MatMenuModule, NotificationsMenuComponent]
})
export class HeaderComponent implements OnInit {
  private store = inject(Store);

  user$: Signal<UserDataResult | null> = this.store.selectSignal(UserSelectors.user);
  availableLanguages$: Signal<string[]> = this.store.selectSignal(GlobalStateSelector.availableLangs);
  currentLang$: Signal<string> = this.store.selectSignal(GlobalStateSelector.currentLang);

  // TODO remove mock data
  notifications = [
    {
      sentAt: '2021-05-20T10:00:00+02:00',
      title: 'Notification 1 title is very long and should be truncated',
    },
    {
      sentAt: '2021-05-20T10:00:00+02:00',
      title: 'Notification 2',
    },
    {
      sentAt: '2021-05-20T10:00:00+02:00',
      title: 'Notification 3',
    },
  ];



  constructor() {
  }

  ngOnInit(): void {
    this.getAvailablesLanguages();
  }

  firstName$ = computed(() => this.user$()?.userData?.given_name ?? '');

  getAvailablesLanguages() {
    this.store.dispatch(new LoadAvailablesLanguages());
  }

  toggleVisibleSideNav() {
    this.store.dispatch(new ChangeNavbar());
  }

  changeLang(currentLang: string) {
    this.store.dispatch(new UpdateCurrentLang(currentLang));
  }

  public logout() {
    this.store.dispatch(new UserLogout());
  }
}
